//#project-detail.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const API_URL = 'https://un-borders.com';

function ProjectDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 حالة عرض الصورة المكبرة
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    axios.get(`${API_URL}/api/projects/${id}/`)
      .then(response => {
        setProject(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("There was an error fetching the project!", error);
        setLoading(false);
      });
  }, [id]);

  // دالة لمنع الحماية (كليك يمين وسحب)
  const preventActions = (e) => {
    e.preventDefault();
  };

  if (loading) return <div>جاري تحميل المشروع...</div>;
  if (!project) return <div>المشروع غير موجود.</div>;

  const getImageUrl = (path) => (path.startsWith('http') ? path : `${API_URL}${path}`);

  // 🔹 وظائف التنقل بين الصور
  const openImage = (index) => {
    setCurrentIndex(index);
    setSelectedImage(getImageUrl(project.images[index].image));
  };

  const closeImage = () => setSelectedImage(null);

  const showNextImage = () => {
    const nextIndex = (currentIndex + 1) % project.images.length;
    setCurrentIndex(nextIndex);
    setSelectedImage(getImageUrl(project.images[nextIndex].image));
  };

  const showPrevImage = () => {
    const prevIndex = (currentIndex - 1 + project.images.length) % project.images.length;
    setCurrentIndex(prevIndex);
    setSelectedImage(getImageUrl(project.images[prevIndex].image));
  };

  return (
    <div className="project-detail" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1>{project.title}</h1>
      </motion.div>

      <div className="main-image-container">
        <motion.img
          src={getImageUrl(project.main_image)}
          alt={project.title}
          onContextMenu={preventActions}
          onDragStart={preventActions}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.7 }}
        />
      </div>

      <div className="details-text">
        <p><strong>الخدمة:</strong> {project.service}</p>
        <p><strong>الموقع:</strong> {project.location}</p>
        <p>{project.description}</p>
      </div>

      <h2>صور إضافية</h2>
      <div className="additional-images-grid">
        {project.images.map((image, index) => (
          <motion.img
            key={index}
            src={getImageUrl(image.image)}
            alt={`صورة ${index + 1}`}
            className="extra-img"
            onContextMenu={preventActions}
            onDragStart={preventActions}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.3 }}
            onClick={() => openImage(index)}
            style={{ cursor: 'pointer' }}
          />
        ))}
      </div>

      <div style={{ marginTop: "30px", textAlign: "center", display: "flex", justifyContent: "center", gap: "15px" }}>
        <button 
          onClick={() => navigate(-1)} 
          style={{
            padding: "10px 20px",
            fontSize: "1rem",
            backgroundColor: "#e0b400",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "bold",
            color: "#1a1a2e"
          }}
        >
          ⬅ الرجوع
        </button>

        <button 
          onClick={() => navigate('/services')} 
          style={{
            padding: "10px 20px",
            fontSize: "1rem",
            backgroundColor: "#2e354a",
            border: "1px solid #e0b400",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "bold",
            color: "#e0b400"
          }}
        >
          قائمة الخدمات
        </button>
      </div>

      {selectedImage && (
        <div className="image-overlay" onClick={closeImage}>
          <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeImage}>✕</button>
            <button className="prev-btn" onClick={showPrevImage}>⟨</button>
            <motion.img
              key={selectedImage}
              src={selectedImage}
              alt="عرض الصورة"
              onContextMenu={preventActions}
              onDragStart={preventActions}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4 }}
            />
            <button className="next-btn" onClick={showNextImage}>⟩</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProjectDetail;